/*
  MyPitz product page behaviour (sections/main-product.liquid):
  - <quantity-breaks>: bundle cards, quantity input, per-unit variant picks
  - <sticky-atc>: bottom bar that submits the main product form
  - .bundle-offer: "buy together" add of several products
  - review carousel height sync, rating-stars scroll links
  Works with Dawn's product-info.js / product-form.js / pubsub.js.
*/
(function () {
  if (window.__mpzProduct) return;
  window.__mpzProduct = true;

  function onVariantChange(cb) {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, cb);
    }
  }

  function findVariant(list, options) {
    return list.find(function (v) {
      return v.options.every(function (o, i) { return options[i] === undefined || o === options[i]; });
    });
  }

  function cartDrawer() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  /* ---------------- quantity bundles ---------------- */
  class QuantityBreaks extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.sectionId = this.dataset.section;
      this.qtyInput = this.querySelector('[data-qb-quantity]');
      try { this.variants = JSON.parse(this.querySelector('[data-qb-variant-options]').textContent); } catch (e) { this.variants = []; }

      this.addEventListener('change', (e) => {
        if (e.target.classList.contains('quantity-breaks__input')) {
          this.qtyInput.value = e.target.value;
          this.qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      const form = document.getElementById(this.dataset.form);
      const host = form && form.closest('product-form');
      if (host) host.addEventListener('submit', (e) => this.beforeSubmit(e, form), true);

      onVariantChange(({ data }) => {
        if (data.sectionId !== this.sectionId) return;
        this.syncFromHtml(data.html, data.variant);
      });
    }

    selectedLabel() {
      const input = this.querySelector('.quantity-breaks__input:checked');
      return input ? input.nextElementSibling : null;
    }

    /* Mixed variants (e.g. #1 white S, #2 black M): send them as separate cart lines. */
    beforeSubmit(e, form) {
      const label = this.selectedLabel();
      if (!label) return;
      const rows = label.querySelectorAll('.quantity-break__selector-item');
      if (!rows.length) return;
      const counts = {};
      let ok = true;
      rows.forEach((row) => {
        const options = [];
        row.querySelectorAll('select[data-option-position]').forEach((sel) => {
          options[Number(sel.dataset.optionPosition) - 1] = sel.value;
        });
        const v = findVariant(this.variants, options);
        if (!v || !v.available) { ok = false; return; }
        counts[v.id] = (counts[v.id] || 0) + 1;
      });
      if (!ok) return;
      const ids = Object.keys(counts);
      const idInput = form.querySelector('input[name="id"]');
      if (ids.length === 1) {
        if (idInput && String(idInput.value) !== ids[0]) idInput.value = ids[0];
        this.qtyInput.value = counts[ids[0]];
        return;
      }
      const added = [];
      ids.forEach((id, i) => {
        [['id', id], ['quantity', counts[id]]].forEach(([k, val]) => {
          const inp = document.createElement('input');
          inp.type = 'hidden';
          inp.name = `items[${i}][${k}]`;
          inp.value = val;
          form.appendChild(inp);
          added.push(inp);
        });
      });
      const off = [idInput, this.qtyInput].filter(Boolean);
      off.forEach((el) => (el.disabled = true));
      setTimeout(() => {
        added.forEach((el) => el.remove());
        off.forEach((el) => (el.disabled = false));
      }, 0);
    }

    syncFromHtml(html, variant) {
      const fresh = html && html.getElementById(`quantity-breaks-${this.sectionId}`);
      if (fresh) {
        this.querySelectorAll('.quantity-break').forEach((label, i) => {
          const src = fresh.querySelectorAll('.quantity-break')[i];
          if (!src) return;
          ['.quantity-break__right', '.quantity-break__image'].forEach((sel) => {
            const a = label.querySelector(sel);
            const b = src.querySelector(sel);
            if (a && b) a.innerHTML = b.innerHTML;
          });
          const ca = label.querySelector('.quantity-break__caption');
          const cb = src.querySelector('.quantity-break__caption');
          if (ca && cb) { ca.textContent = cb.textContent; ca.style.display = cb.style.display; }
        });
      }
      if (variant) {
        this.querySelectorAll('select[data-option-position]').forEach((sel) => {
          const val = variant.options[Number(sel.dataset.optionPosition) - 1];
          if (val !== undefined) sel.value = val;
        });
      }
    }
  }
  if (!customElements.get('quantity-breaks')) customElements.define('quantity-breaks', QuantityBreaks);

  /* ---------------- sticky add to cart ---------------- */
  class StickyAtc extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.sectionId = this.dataset.section;
      this.form = document.getElementById(this.dataset.form);
      this.mainButton = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
      this.button = this.querySelector('.sticky-atc__btn');

      this.button.addEventListener('click', () => {
        if (!this.form) return;
        const spinner = this.button.querySelector('.loading__spinner');
        this.button.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');
        const done = () => {
          this.button.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        };
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          const un = subscribe(PUB_SUB_EVENTS.cartUpdate, () => { done(); un(); });
          setTimeout(done, 6000);
        }
        if (this.form.requestSubmit) this.form.requestSubmit(); else this.form.querySelector('[type="submit"]').click();
      });

      const select = this.querySelector('.sticky-atc__variant-select');
      if (select) select.addEventListener('change', () => this.applyVariant(select));

      if (this.mainButton && 'IntersectionObserver' in window) {
        new IntersectionObserver((entries) => {
          entries.forEach((en) => this.toggle(!en.isIntersecting));
        }).observe(this.mainButton);
      } else {
        this.toggle(true);
      }
      window.addEventListener('resize', () => this.publishHeight(), { passive: true });

      onVariantChange(({ data }) => {
        if (data.sectionId !== this.sectionId) return;
        const fresh = data.html && data.html.getElementById(`sticky-atc-price-${this.sectionId}`);
        const price = this.querySelector(`#sticky-atc-price-${this.sectionId}`);
        if (fresh && price) price.innerHTML = fresh.innerHTML;
        const freshImg = data.html && data.html.getElementById(`sticky-atc-image-${this.sectionId}`);
        const img = this.querySelector(`#sticky-atc-image-${this.sectionId}`);
        if (freshImg && img) { img.srcset = freshImg.srcset; img.src = freshImg.src; }
        if (select && data.variant) select.value = String(data.variant.id);
        this.button.disabled = !(data.variant && data.variant.available);
      });
    }

    toggle(show) {
      this.classList.toggle('sticky-atc--visible', show);
      this.setAttribute('aria-hidden', show ? 'false' : 'true');
      this.publishHeight();
    }

    publishHeight() {
      const h = this.classList.contains('sticky-atc--visible') ? this.offsetHeight : 0;
      document.documentElement.style.setProperty('--mpz-sticky-atc-h', `${h}px`);
    }

    /* Move the main variant picker to the variant chosen in the sticky select. */
    applyVariant(select) {
      const opt = select.selectedOptions[0];
      let options = [];
      try { options = JSON.parse(opt.dataset.options); } catch (e) { return; }
      const picker = document.getElementById(`variant-selects-${this.sectionId}`);
      if (!picker) return;
      let changed = null;
      picker.querySelectorAll('fieldset, .product-form__input--dropdown').forEach((group, i) => {
        const value = options[i];
        if (value === undefined) return;
        const sel = group.querySelector('select');
        if (sel) {
          const o = [...sel.options].find((x) => x.value === value);
          if (o && !o.selected) { sel.value = value; changed = sel; }
          return;
        }
        const radio = [...group.querySelectorAll('input[type="radio"]')].find((r) => r.value === value);
        if (radio && !radio.checked) { radio.checked = true; changed = radio; }
      });
      if (changed) changed.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  if (!customElements.get('sticky-atc')) customElements.define('sticky-atc', StickyAtc);

  /* ---------------- bundle offer ---------------- */
  function formatMoney(cents, format) {
    const fmt = format || '{{amount}}';
    const value = (cents / 100).toFixed(2);
    const withCommas = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, value.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas);
  }

  function initBundle(bo) {
    if (bo.__mpzBo) return;
    bo.__mpzBo = true;
    const fmt = bo.dataset.moneyFormat;
    const freeText = (bo.querySelector('.bundle-deals__price-js') || {}).textContent;

    function rowState(row) {
      let variants = [];
      try { variants = JSON.parse(row.querySelector('[data-bo-variants]').textContent); } catch (e) {}
      const options = [];
      row.querySelectorAll('select[data-option-position]').forEach((sel) => {
        options[Number(sel.dataset.optionPosition) - 1] = sel.value;
      });
      const v = options.length ? findVariant(variants, options) : variants.find((x) => String(x.id) === row.dataset.variantId);
      return { v };
    }

    function recalc() {
      let total = 0;
      let compare = 0;
      let base = 0;
      bo.querySelectorAll('.upsell--bundle').forEach((row) => {
        const { v } = rowState(row);
        if (!v) return;
        row.dataset.variantId = v.id;
        const pct = Number(row.dataset.pct) || 0;
        const fixed = Number(row.dataset.fixed) || 0;
        const price = Math.max(0, Math.round((v.price * (100 - pct)) / 100 - fixed));
        const cmp = Math.max(v.price, v.compare || 0);
        total += price;
        compare += cmp;
        base += v.price;
        const p = row.querySelector('.bundle-deals__price-js');
        if (p && !(price === 0 && p.classList.contains('mp-free'))) {
          p.textContent = price === 0 && freeText && !/\d/.test(freeText) ? freeText : formatMoney(price, fmt);
        }
        const c = row.querySelector('.bundle-deals__compare-price-js');
        if (c) { c.textContent = formatMoney(cmp, fmt); c.hidden = !(cmp > price); }
        const img = row.querySelector('.upsell__image__img');
        if (img && v.image) { img.removeAttribute('srcset'); img.src = v.image; }
      });
      const t = bo.querySelector('.bundle-deals__total-price-js');
      const tc = bo.querySelector('.bundle-deals__total-compare-price-js');
      if (t) t.textContent = formatMoney(total, fmt);
      if (tc) { tc.textContent = formatMoney(compare, fmt); tc.hidden = !(compare > total); }
      const tb = bo.querySelector('.bundle-deals__total-base-js');
      if (tb) tb.dataset.cents = base;
    }

    bo.addEventListener('change', (e) => {
      if (e.target.matches('select[data-option-position]')) recalc();
    });

    const host = bo.querySelector('product-form');
    if (!host) return;
    host.addEventListener('submit', (e) => {
      e.preventDefault();
      e.stopPropagation();
      const button = host.querySelector('[type="submit"]');
      const err = host.querySelector('.product-form__error-message-wrapper');
      const items = [];
      bo.querySelectorAll('.upsell--bundle').forEach((row) => {
        const { v } = rowState(row);
        if (v) items.push({ id: v.id, quantity: 1 });
      });
      if (!items.length) return;
      const cart = cartDrawer();
      const body = { items };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = window.location.pathname;
      }
      button.classList.add('loading');
      button.setAttribute('aria-disabled', 'true');
      const spinner = button.querySelector('.loading__spinner');
      if (spinner) spinner.classList.remove('hidden');
      fetch(`${window.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      })
        .then((r) => r.json())
        .then((res) => {
          if (res.status) {
            if (err) { err.hidden = false; err.querySelector('.product-form__error-message').textContent = res.description || res.message; }
            return;
          }
          if (err) err.hidden = true;
          if (cart && cart.renderContents) {
            cart.classList.contains('is-empty') && cart.classList.remove('is-empty');
            cart.renderContents(res);
          } else {
            window.location = window.routes.cart_url;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bundle-offer', cartData: res });
          }
        })
        .catch(() => {})
        .finally(() => {
          button.classList.remove('loading');
          button.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    }, true);
  }

  /* ---------------- reviews carousel (height follows the visible card) ---------------- */
  function initReviews(root) {
    if (root.__mpzRv) return;
    root.__mpzRv = true;
    const track = root.querySelector('.reviews-snap__track');
    if (!track) return;
    function step() {
      const c = track.querySelector('.review-item');
      return c ? Math.round(c.getBoundingClientRect().width) + 24 : track.clientWidth;
    }
    root.querySelectorAll('.reviews-snap__arrow').forEach((b) => {
      b.addEventListener('click', () => {
        const d = b.dataset.dir === 'prev' ? -1 : 1;
        track.scrollBy({ left: d * step(), behavior: 'smooth' });
      });
    });
    function syncH() {
      const tr = track.getBoundingClientRect();
      const mid = tr.left + tr.width / 2;
      let best = 1e9;
      let a = null;
      track.querySelectorAll('.review-item').forEach((c) => {
        const r = c.getBoundingClientRect();
        const dd = Math.abs(r.left + r.width / 2 - mid);
        if (dd < best) { best = dd; a = c; }
      });
      if (a) track.style.height = `${a.scrollHeight}px`;
      const dots = root.querySelectorAll('.reviews-snap__dot');
      if (dots.length && a) {
        const items = [...track.querySelectorAll('.review-item:not([data-mp-clone])')];
        const idx = items.indexOf(a);
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
      }
    }
    let rf;
    track.addEventListener('scroll', () => { if (rf) cancelAnimationFrame(rf); rf = requestAnimationFrame(syncH); });
    window.addEventListener('resize', () => requestAnimationFrame(syncH));
    window.addEventListener('load', syncH);
    requestAnimationFrame(syncH);
  }

  function init(root) {
    (root || document).querySelectorAll('.bundle-offer').forEach(initBundle);
    (root || document).querySelectorAll('.reviews-snap--slider').forEach(initReviews);
    (root || document).querySelectorAll('.mpz-rating-stars[data-scroll-to]').forEach((el) => {
      if (el.__mpzScroll) return;
      el.__mpzScroll = true;
      el.addEventListener('click', () => {
        const target = document.getElementById(el.dataset.scrollTo);
        if (target) target.scrollIntoView({ behavior: 'smooth' });
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
